import {
    GET_WIDGETS_REQUEST,
    GET_WIDGETS_SUCCESS,
    GET_WIDGETS_ERROR,
    UPDATE_WIDGET_REQUEST,
    UPDATE_WIDGET_SUCCESS,
    UPDATE_WIDGET_ERROR,
    REORDER_WIDGETS_REQUEST,
    REORDER_WIDGETS_SUCCESS,
    REORDER_WIDGETS_ERROR
} from './types';

const initialState = {
    widgets: [],
    loading: false,
    error: null
};

const widgetsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_WIDGETS_REQUEST:
            return { ...state, loading: true, error: null };

        case UPDATE_WIDGET_REQUEST:
        case REORDER_WIDGETS_REQUEST:
            return { ...state, error: null };

        case GET_WIDGETS_SUCCESS:
            return { ...state, loading: false, widgets: payload };

        case UPDATE_WIDGET_SUCCESS:
            return {
                ...state,
                loading: false,
                widgets: state.widgets.map(w =>
                    w.widgetID === payload.widgetID ? { ...w, ...payload } : w
                ),
            };

        case REORDER_WIDGETS_SUCCESS:
            return { ...state, loading: false };

        case GET_WIDGETS_ERROR:
        case UPDATE_WIDGET_ERROR:
        case REORDER_WIDGETS_ERROR:
            return { ...state, loading: false, error: true };

        default:
            return state;
    }
};

export default widgetsReducer;
